import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { FaCampground, FaSignOutAlt, FaUserShield } from "react-icons/fa";
import { AuthContext } from "../../context/AuthContext";
import CampPeopleAttendance from "../../components/camp/CampPeopleAttendance";

const ManagerAttendance = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-slate-100">
      <header className="border-b border-slate-200 bg-white shadow-sm">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4">
          <div className="flex items-center gap-3">
            <div className="rounded-xl bg-indigo-700 p-3 text-white"><FaUserShield /></div>
            <div><h1 className="font-bold text-slate-900">Camp Manager Portal</h1><p className="text-xs text-slate-500"><FaCampground className="mr-1 inline" /> Attendance management · {user?.name}</p></div>
          </div>
          <button type="button" onClick={handleLogout} className="inline-flex items-center gap-2 rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-xs font-bold text-rose-700"><FaSignOutAlt /> Logout</button>
        </div>
      </header>
      <main className="mx-auto max-w-7xl p-4 sm:p-6"><CampPeopleAttendance campId={user?.camp_id} /></main>
    </div>
  );
};

export default ManagerAttendance;
